module.exports = __webpack_public_path__ + "assets/joomla.2fbf538a.svg";